import { RequestData } from '@ant-design/pro-components';

import { request } from '@umijs/max';

import {
  CreateReportRequest,
  CreateSignedUrlRequest,
  CreateSignedUrlResponse,
  DeleteRequest,
  ReportsResponse,
  RequestParams,
} from '@/types';

export async function getReports(params: RequestParams): Promise<RequestData<ReportsResponse>> {
  return request('reports', {
    method: 'GET',
    params,
  });
}

export async function createReport(payload: CreateReportRequest) {
  return request('reports', {
    data: payload,
    method: 'POST',
    responseType: 'arraybuffer',
  });
}

export async function createSignedUrl(payload: CreateSignedUrlRequest): Promise<CreateSignedUrlResponse> {
  return request('reports/create-signed-url', {
    data: payload,
    method: 'POST',
  });
}

export async function deleteReport({ id }: DeleteRequest): Promise<ReportsResponse> {
  return request(`reports/${id}`, {
    method: 'DELETE',
  });
}
